export function booleanSelect(value, fallback) {
  const normalized = String(value ?? '').trim().toLowerCase()
  return ['true', 'false'].includes(normalized) ? normalized : fallback
}

export function loginThemeSelect(value) {
  const normalized = String(value ?? '').trim().toLowerCase()
  return ['white', 'black'].includes(normalized) ? normalized : 'white'
}
